import { render, staticRenderFns } from "./region.vue?vue&type=template&id=59d95696&"
import script from "./region.vue?vue&type=script&lang=js&"
export * from "./region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports